import { render, staticRenderFns } from "./ManageTable.vue?vue&type=template&id=0e22887c&scoped=true&"
import script from "./ManageTable.vue?vue&type=script&lang=js&"
export * from "./ManageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e22887c",
  null
  
)

export default component.exports